import { Link } from "react-router-dom";
import { ShareButtons } from "./ShareButtons";
import { openCookiePreferences } from "@/lib/consent";

export const Footer = () => (
  <footer className="bg-[#15201A] text-white pt-20 pb-10 overflow-hidden" data-testid="site-footer">
    <p className="font-serif-display font-light text-[clamp(2.5rem,8vw,10rem)] leading-none text-white/20 whitespace-nowrap select-none text-center" aria-hidden="true">
      Dentista Sostenibile
    </p>
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="relative">
              <img
                src="/logo-gsi.png"
                alt="Gruppo Stomatologico Italiano"
                loading="lazy"
                decoding="async"
                className="h-12 w-12 object-contain bg-white rounded-full"
              />
              <span className="absolute -top-1 -right-1.5 text-[10px] font-bold text-white" aria-label="Marchio registrato">®</span>
            </span>
            <div>
              <p className="font-serif-display text-2xl">Dentista <em className="italic text-[#7D9285]">Sostenibile</em></p>
              <p className="text-[10px] uppercase tracking-[0.18em] font-bold text-white/40">Gruppo Stomatologico Italiano</p>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
            Rete di studi odontoiatrici convenzionati per l'implantologia a carico immediato.
            Ogni studio è autonomo, con propria P.IVA e direttore sanitario indipendente.
          </p>
          <p className="mt-4 text-sm text-white/70">
            Numero verde 24/7: <a href="tel:800628192" className="font-bold text-white hover:text-[#C98E6E] transition-colors duration-300" data-testid="footer-tollfree">800 628 192</a>
          </p>
        </div>
        <div>
          <p className="text-sm uppercase tracking-[0.15em] font-bold text-white/40 mb-4">Sito</p>
          <ul className="space-y-3 text-white/70">
            <li><a href="#come-funziona" className="hover:text-white transition-colors duration-300">Come funziona</a></li>
            <li><a href="#prezzo" className="hover:text-white transition-colors duration-300">Trasparenza prezzi</a></li>
            <li><a href="#studi" className="hover:text-white transition-colors duration-300">Gli studi</a></li>
            <li><a href="#faq" className="hover:text-white transition-colors duration-300">FAQ</a></li>
          </ul>
        </div>
        <div>
          <p className="text-sm uppercase tracking-[0.15em] font-bold text-white/40 mb-4">Impianti dentali nella tua città</p>
          <ul className="space-y-3 text-white/70">
            <li><Link to="/impianti-dentali-milano" className="hover:text-white transition-colors duration-300" data-testid="footer-city-milano">Impianti dentali provincia di Milano e Monza Brianza</Link></li>
            <li><Link to="/impianti-dentali-novara" className="hover:text-white transition-colors duration-300" data-testid="footer-city-novara">Impianti dentali Novara</Link></li>
            <li><Link to="/impianti-dentali-torino" className="hover:text-white transition-colors duration-300" data-testid="footer-city-torino">Impianti dentali Chivasso (TO)</Link></li>
            <li><Link to="/impianti-dentali-bergamo" className="hover:text-white transition-colors duration-300" data-testid="footer-city-bergamo">Impianti dentali Seriate (Bergamo)</Link></li>
            <li><Link to="/impianti-dentali-palermo" className="hover:text-white transition-colors duration-300" data-testid="footer-city-palermo">Impianti dentali Palermo</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-sm uppercase tracking-[0.15em] font-bold text-white/40 mb-4">Legale</p>
          <ul className="space-y-3 text-white/70">
            <li><Link to="/privacy-policy" className="hover:text-white transition-colors duration-300" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-white transition-colors duration-300" data-testid="footer-cookie-link">Cookie Policy</Link></li>
            <li><button type="button" onClick={openCookiePreferences} className="hover:text-white transition-colors duration-300 text-left" data-testid="footer-manage-cookies">Gestisci cookie</button></li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/10">
        <ShareButtons dark />
      </div>
      <div className="mt-8 pt-8 border-t border-white/10 text-xs text-white/40 leading-relaxed">
        <p>© {new Date().getFullYear()} dentistasostenibile.com — Informazione sanitaria ai sensi della L. 145/2018. I prezzi indicati sono indicativi e soggetti a valutazione clinica. Direttore sanitario indipendente presso ogni studio convenzionato.</p>
      </div>
    </div>
  </footer>
);
